function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

export default function filterTree(items, predicate) {
  var filterItem = function filterItem(filteredItems, item) {
    if (item.children != null) {
      var filteredChildren = item.children.reduce(filterItem, []);

      if (filteredChildren.length > 0) {
        filteredItems.push(_extends({}, item, {
          children: filteredChildren
        }));
      }
    } else if (predicate(item)) {
      filteredItems.push(item);
    }

    return filteredItems;
  };

  return items.reduce(filterItem, []);
}